import Resource from './Resource';
import LeaderPageAttributes from 'App/babel/attributes/LeaderPageAttributes';
import type RequestBuilder from 'Resources/RequestBuilder';

type LeaderPageEntity = { id: number; name: string; url: string; pageImpression: number };

class LeaderPage extends Resource {
	eventName = 'leaderPage';

	constructor() {
		super('pages', LeaderPageAttributes);

		this.notifications = {
			save: () => ({
				title: 'default.updated',
				body: 'updated.page',
				style: 'success',
				icon: 'check',
				type: 'body'
			}),
			saveError: () => ({
				title: 'default.error',
				body: 'saveError.page',
				style: 'error',
				icon: 'times',
				type: 'body'
			}),
			delete: () => ({ title: 'default.deleted', body: '', style: 'success', icon: 'check', type: 'body' }),
			deleteError: () => ({
				title: 'default.error',
				body: 'deleteError.page',
				style: 'error',
				icon: 'times',
				type: 'body'
			})
		} as any;
	}

	find(filters: ReturnType<RequestBuilder['build']>): Promise<{ metadata: any; data: LeaderPageEntity[] }> {
		return this._getRequest('', { methodName: 'find', params: filters }).then((res: any) => res.data);
	}

	save(page: { id: any; hide?: boolean }, options: Record<string, unknown> = {}) {
		return this._putRequest(String(page.id), { page }, { methodName: 'save', ...options }).then((res: any) => {
			this._triggerEvent(options, 'updated', { data: res.data.data });
			return res;
		});
	}

	delete(page: { id: number }, options: Record<string, unknown> = {}) {
		return this._deleteRequest(String(page.id), { methodName: 'delete', ...options }).then((res: any) => {
			this._triggerEvent(options, 'deleted', { data: page });
			return res;
		});
	}
}

export default new LeaderPage();
